module.exports = __webpack_public_path__ + "media/images/slide_prev_btn-afe6c11533cee107c32fd0612fc9d47c.png";